import { Component, Input } from '@angular/core';

@Component({
  selector: 'bidi-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  @Input() url = 'assets/images/loading.svg';
  @Input() scale = 1;
}
